import React from 'react';
import { Handler } from 'ml-component-web';

export default class AboutHandler extends Handler {
    renderHandler() {
        return (
            <div className="page-content container">
                <h1>About</h1>
                <p>
                    MyBabyBio is the Online Baby Diary, available to download now on iOS and Android.
                </p>
                <h2>Our aim</h2>
                <p>
                    To offer a safer, more secure environment where families can record and share their memories.
                </p>
                <h2>Our values</h2>
                <p>
                    <ol>
                        <li><strong>Privacy, privacy, privacy</strong> – your family’s privacy is our single most important focus. You as parents are in control and always will be, so no more worrying about who sees photos of your child, sharenting, oversharing or whatever else it might be called today.</li>
                        <li><strong>Memories are precious</strong> – everything you add is backed up safely and securely to the cloud so you don’t have to worry about losing your most important photos and memories ever again.</li>
                        <li><strong>Simplicity</strong> – we know how little time parents have, so we want everything to be as simple and easy to use as possible.</li>
                        <li><strong>Listen</strong> – we will listen, help, support and actively <a href="mailto:support@mybabybio.com">want your feedback</a> to ensure that MyBabyBio is exactly what you as parents want and need.</li>
                    </ol>
                </p>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/AboutHandler.js
 **/